import React from "react";
import * as SRD from '@projectstorm/react-diagrams';
import { Container } from "./Styled";
import { PortWidget } from "@projectstorm/react-diagrams";

type BasePortProps = {
    port: SRD.PortModel;
    engine: SRD.DiagramEngine,
    style: any
}

const BasePort: React.FunctionComponent<BasePortProps> = (props) => {
  const hasLink = () => {
    return Object.keys(props.port.getLinks()).length > 0;
  }
  return (
    // @ts-ignore
    <PortWidget
      {...props}
      style={{
        ...props.style,
        width: "13px",
        height: "13px"
      }}
    >
      <Container isConnected = {hasLink()}></Container>
    </PortWidget>
  );
};

export default BasePort;
